import React from 'react'
import { FormControlLabel, Switch } from '@material-ui/core'

function OpcionesConfiguracionPesado (props) {
  const { equilibrio, pesadoAuto, sinEgresoCalado, pedirConfirmacion, rolAutorizado = false, enclavamientoBarreras, tipoPesado } = props

  return (
    <>
      <FormControlLabel
        control={<Switch
          color='primary'
          name='enclavamiento'
          onChange={props.updateEnclavamiento}
          checked={equilibrio === 1}
          disabled={!rolAutorizado}
        />
        }
        label='Enclavamiento / Equilibrio'
      />

      <FormControlLabel
        control={<Switch
          color='primary'
          name='pesadoAuto'
          onChange={props.updateModoPesado}
          checked={pesadoAuto}
          disabled={!rolAutorizado}
        />}
        label='Pesaje automatico'
      />

      <FormControlLabel
        control={<Switch
          color='primary'
          name='sinEgresoCalado'
          onChange={props.updatePesoSinEgresoCalado}
          checked={sinEgresoCalado === 1}
          disabled={!rolAutorizado || (tipoPesado === 'Pesado subproducto')}
        />}
        label='Permitir sin egreso de calado'
      />

      <FormControlLabel
        control={<Switch
          color='primary'
          name='pedirConfirmacion'
          onChange={props.updatePedidoDeConfirmacion}
          checked={pedirConfirmacion === 1}
          disabled={!rolAutorizado || (tipoPesado === 'Pesado subproducto')}
        />}
        label='Pedir confirmación de chofer'
      />

      <FormControlLabel
        style={{ width: '100%' }}
        control={
          <Switch
            color='primary'
            name='enclavamientoBarrerasBruto'
            onChange={props.updateEnclavamientoBarreras}
            checked={enclavamientoBarreras === 1}
            disabled={!rolAutorizado}
          />
        }
        label='Enclavamiento barreras'
      />

    </>
  )
}

export default OpcionesConfiguracionPesado
